import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { 
  getTripPlansByUser, 
  canUserCreateTripPlan 
} from '../../utils/tripPlanUtils';
import TripPlanList from './TripPlanList';
import TripPlanModal from './TripPlanModal';
import TripPlanViewer from './TripPlanViewer';

const TripPlanSelector = ({ 
  onSelectTripPlan, 
  onClose, 
  selectedTripPlan = null 
}) => {
  const { currentUser } = useAuth();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewer, setShowViewer] = useState(false);
  const [viewingTripPlan, setViewingTripPlan] = useState(null);

  // Check if user can create trip plans
  const canCreate = canUserCreateTripPlan(currentUser?.role);

  const handleSelectTripPlan = (tripPlan) => {
    onSelectTripPlan(tripPlan);
    onClose();
  };

  const handleViewTripPlan = (tripPlan) => {
    setViewingTripPlan(tripPlan);
    setShowViewer(true);
  };

  const handleCloseViewer = () => {
    setShowViewer(false);
    setViewingTripPlan(null);
  };

  const handleCreateSuccess = () => {
    setShowCreateModal(false);
    // The TripPlanList will automatically refresh
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">เลือก Trip Plan</h2>
              <p className="text-gray-600 mt-1">
                เลือกทริปที่ต้องการจองคิว หรือสร้างทริปใหม่
              </p>
            </div>
            <div className="flex gap-3">
              {canCreate && (
                <button
                  onClick={() => setShowCreateModal(true)}
                  className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                >
                  ➕ สร้างทริปใหม่
                </button>
              )}
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
              >
                ปิด
              </button>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <TripPlanList
            onEditTripPlan={() => {}} // Disable edit in selector mode
            onViewTripPlan={handleViewTripPlan}
            onSelectTripPlan={handleSelectTripPlan}
            isSelectable={true}
            selectedTripPlan={selectedTripPlan}
          />
        </div>

        {/* Selected Trip Plan Info */}
        {selectedTripPlan && (
          <div className="p-6 bg-blue-50 border-t border-blue-200">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-blue-900">ทริปที่เลือก:</h3>
                <p className="text-blue-800">{selectedTripPlan.tripName}</p>
                <p className="text-blue-600 text-sm">
                  {new Date(selectedTripPlan.tripDate).toLocaleDateString('th-TH')} • 
                  {selectedTripPlan.tripLocation}
                </p>
              </div>
              <button
                onClick={() => handleSelectTripPlan(selectedTripPlan)}
                className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
              >
                ✅ ยืนยันการเลือก
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modals */}
      {showCreateModal && (
        <TripPlanModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onSuccess={handleCreateSuccess}
        />
      )}

      {showViewer && viewingTripPlan && (
        <TripPlanViewer
          tripPlan={viewingTripPlan}
          onClose={handleCloseViewer}
          onSelect={handleSelectTripPlan}
          isSelectable={true}
        />
      )}
    </div>
  );
};

export default TripPlanSelector;









